import React from 'react'

import Wizard from '@modules/form-wizard'
import SERVICE_PROPS from '@helpers/extract-service-props'
import { OPENMAPFIELDS } from '@modules/open-street-map-field'
import moment from 'moment'
import Swal from 'sweetalert2'
import toastr from '@modules/toastr'
import { fullName } from '@modules/form-wizard/utils'

export default class VectorComplaint extends React.Component {
  resource = '/moen/health/vector_complaints'
  form_key = 'vector_complaint'
  defaults = {}

  // Delete lines as needed
  fee = 99
  free = true
  postpaid = true
  skip_location = true
  hide_buttons = false
  custom_actions = [
    {
      text: 'Assign Officer',
      icon: 'bullhorn',
      roles: [['senior_officer']],
      test: r => ['pending', 'processing'].includes(r.application_decision),
      fn: async record => {
        // Get the list of officers
        const officerList = {};
        const { data } = await $app.axios.get(`${this.resource}/show_field_officers`)
        const officerMap = data.records.map(x => {
          return { id: x.id, name: `${x.first_name} ${x.last_name}` }
        })
        this.setState({ all_reviewers: officerMap })
        this.state.all_reviewers.forEach(e => {
          officerList[`${e.id}`] = e.name;
        })

        let officerID = null
        const {isDismissed, value} = await Swal.fire({
          icon: 'question',
          title: 'Assign Officer for inspection',
          html: `
            Select which field officer you would wish to assign to this application.
          `,
          input: 'select',
          inputOptions: officerList,
          showCancelButton: true,
          confirmButtonText: 'Send',
        })
  
        if (isDismissed) return
        officerID = value
        // console.log(officerID)

        const { props, resource, form_key } = this
        const { history, location } = props

        try {
          await $app.axios.put(resource + '/update_application', {
            [form_key]: {
              form_num: record.form_num,
              application_decision: 'assign reviewer',
              reviewer_id: officerID,
            },
          })

          if (location?.state?.view) {
            const view = { ...location.state.view }
            console.log(view)
            view.application_decision = 'assigned reviewer'

            history.replace(location.pathname, {
              ...location.state,
              view,
            })
          }

          toastr.success('Success', 'Application approved for review successfully')
        } catch (error) {
          console.error(error)
          Swal.fire(
            'Oops...',
            error.response?.data?.error || 'An error occurred while approving the application for review',
            'error'
          )
        }
      }
    },
    {
      text: 'Claim Application',
      icon: 'check',
      roles: [['senior_officer']],
      test: r => {
        if (['pending', 'processing'].includes(r.application_decision) && r.reviewer_id == null) {
          return true
        }

        if (['pending', 'processing'].includes(r.application_decision) && $app.current_user.roles.includes('senior_officer') && r.reviewer_id != $app.current_user.id) {
          return true
        }

        return false
      },
      fn: async record => {
        const { isDismissed, value } = await Swal.fire({
          icon: 'question',
          title: 'Claim Application for Review',
          html: `
            Are you claiming this application for review, 
            <strong>${fullName(record.user, 'initial')}</strong>?
          `,
          input: 'select',
          inputOptions: {
            'claimed': "I claim this application for review",
            'no': "I do not wish to claim this application",            
          },
          showCancelButton: true,
        })

        if (isDismissed) return
        if (value === 'no') return

        await this.submitToNewLevel(value, record, null)
      }
    },
    {
      text: 'Approve',
      icon: 'check',
      roles: [['field_officer', 'inspector', 'senior_officer']],
      test: r => {
        if (['pending', 'processing', 'document requested'].includes(r.application_decision) && r.reviewer_id == $app.current_user.id) {
          return true
        }

        return false
      },
      fn: record =>
        Swal.fire({
          icon: 'success',
          title: 'Confirm Approval',
          text: 'Are you sure you want to approve this application?',
          confirmButtonText: 'Approve',
          showCancelButton: true,
        }).then(async result => {
          if (result.isConfirmed) {
            // await this.approve(record)
          }
        }),
    },
    {
      text: 'Deny',
      icon: 'ban',
      roles: [['field_officer', 'inspector', 'senior_officer']],
      test: r => {
        if (['pending', 'processing', 'document requested'].includes(r.application_decision) && r.reviewer_id == $app.current_user.id) {
          return true
        }

        return false
      },
      fn: record =>
        Swal.fire({
          icon: 'error',
          title: 'Confirm Denial',
          text: 'Are you sure you want to deny this application?',
          confirmButtonText: 'Deny',
          showCancelButton: true,
        }).then(async result => {
          if (result.isConfirmed) {
            // await this.deny(record)
          }
        }),
    },
  ]

  submitToNewLevel = async (value, record, inspectionDate = null) => {
    this.setState({ loading: true })
    const { resource, form_key } = this
    const { axios } = $app

    try {
      await axios.put(resource + '/update_application', {
        [form_key]: {
          form_num: record.form_num,
          application_decision: value,
          inspection_date: inspectionDate,
        },
      })

      toastr.success('Success', 'The application was successfully updated')
    } catch (error) {
      console.error(error)
      toastr.error('Error', error.response?.data?.error || 'Something went wrong with trying to update this application')
    } finally {
      this.setState({ loading: false })
    }
  }

  columns = props => [
    {
      name: 'Inspection Date',
      selector: row => row.inspection_date ? moment(row.inspection_date).format('MMMM Do YYYY, h:mm a') : 'N/A',
      sortable: true,
      searchable: r => r.inspection_date,
    },
  ]

  validate = async form => {
    const update = {}
    const complaintsArray = Array.from(form.complaint_type || []) // Convert Checklist of type Set to Array
    update.complaint_type = complaintsArray

    // Validation: Ensure at least one complaint type is selected
    if (complaintsArray.length === 0) {
      return 'No complaint types were selected'
    }

    if (form.property_classification.trim() === "") {
      return 'No property classification was selected'
    }

    if(this.coordinates) {
      update.latitude = this.coordinates[0]
      update.longitude = this.coordinates[1]
    }

    return update
  }

  foremost = null

  fields = (form, formRef) => [
    "::Contact Information",
    {
      name: "work_number", 
      label: "Work Phone #", 
      type: "phone",
      required: false,
    },
    {
      name: "home_number", 
      label: "Home Phone #", 
      type: "phone",
      required: false,
    },
    {
      name: "mobile_number", 
      label: "Mobile Phone #", 
      type: "phone",
    },

    "::Complaint Details",
    {
      name: "complaint_type",
      label: "Nature of Complaint",
      type: "checklist",
      multi: true,
      options: [
        "Rodents",       
        "House Flies",           
        "Cockroaches",
        "Mosquitoes",
        "Other"     
      ]
    },
    {
      name: "complaint_desc",
      label: "Give Details",
      type: "textarea",
      hint: `Please provide any additional details that may assist in the investigation of your complaint
      `,
      required: Array.from(form.complaint_type || []).includes("Other") // Make this field required if "Other" is selected in the complaint_type checklist
    },

    {
      name: "property_classification",
      label: "Property Classification",
      type: "checklist",
      single: true,
      options: [
        { label: "Residential - Occupied Building", value: "residential - occupied building" },
        { label: "Residential - Vacant Lot", value: "residential - vacant lot" },
        { label: "Residential - Abandoned Building", value: "residential - abandoned building" },
        { label: "Governmental - School", value: "governmental - school" },
        { label: "Governmental - Clinic", value: "governmental - clinic" },
        { label: "Governmental - Police", value: "governmental - police" },
        { label: "Governmental - Defence Force", value: "governmental - defence force" },
        { label: "Other", value: "other" },
      ]
    },
    {
      name: "property_classification_desc",
      label: "Give Details",
      type: "textarea",
      hint: `Any additional details about the property classification that may assist in the investigation of your complaint
      `,
      required: form.property_classification === "other" // Make this field required if "Other" is selected in the property_classification checklist
    },

    {
      name: "property_condition",
      label: "Property/Premises Condition",
      type: "checklist",
      multi: true,
      options: [ 
        "Garbage Accumulation",
        "Overgrown Vegetation",
        "Derelict Vehicles",
        "Inadequate Garbage Storage",
        { label: "Other", value: "other" },
      ],
      hint: "Select all that apply",
    },
    {
      name: "property_condition_desc",
      label: "Give Details",
      type: "textarea",
      hint: `Any additional details about the property condition that may assist in the investigation of your complaint 
      `,
      required: Array.from(form.property_condition || []).includes("other") // Make this field required if "Other" is selected in the property_condition checklist
    },

    "::Location of Complaint/Request",
    ...OPENMAPFIELDS(this, form, formRef, null),
    {
      name: "complaint_location",
      label: "Location of Complaint",
      type: "textarea",
      hint: "Detailed directions and street address where complaint is located"
    },
  ]

  render = () => <Wizard {...SERVICE_PROPS(this)} />
}
